<template>
  <IconLucideUserPlus />
</template>
